
import * as Tippy from 'tippy.js/dist/tippy.all.min.js';

export class TooltipsService {

	constructor() {}

	static initTooltips() : Tippy {

		return Tippy('[title]', {
		   placement: 'top',
		   animation: 'fade',
		   duration: 750,
		   arrow: true
	   });

	}

}



// WEBPACK FOOTER //
// ./services/tooltips.service.ts